import React from 'react';

import { UiKit } from 'components';
import { useRefundMethodToggle } from '../context';

export default function Switch({ label = '' }) {
  const { isActive, isProcessing, onToggle } = useRefundMethodToggle();

  return (
    <UiKit.Toggle
      direction="rtl"
      label={label}
      isActive={isActive}
      onChange={onToggle}
      disabled={isProcessing}
    />
  );
}
